import { useMemo } from 'react';
import { useData } from '@microsoft/teamsfx-react';

import useApi from 'src/hooks/useApi';
import { mapInterestsToIcons } from 'src/utils/iconUtils';
import { ImageIcon } from 'src/ui-models/Icon';

export const useInterestIcons = (): {
  interestIcons: ImageIcon[]
  loadInterestsError: unknown
  isLoadingInterests: boolean
} => {
  const apiHook = useApi();
  const { loading: isLoadingInterests, error: loadInterestsError, data: interests } = useData(apiHook.api.getInterests);
  const interestIcons = useMemo(() => mapInterestsToIcons(interests), [interests]);

  return { interestIcons, loadInterestsError, isLoadingInterests };
};
